// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".legislation_content-module__text--3mhri{margin-bottom:0px;margin-top:8px;display:inline-block;width:100%;padding-bottom:4px}.legislation_content-module__text--3mhri table{border-collapse:collapse;width:100%}.legislation_content-module__display--2D1dV{display:inline-block;color:#36b;cursor:pointer}\n", ""]);
// Exports
exports.locals = {
	"text": "legislation_content-module__text--3mhri",
	"display": "legislation_content-module__display--2D1dV"
};
module.exports = exports;
